export enum GridApplicationDocumentTypes {
  CircuitDiagram = 'circuit_diagram',
  UnitCertificate = 'unit_certificate',
  PhotovoltaicDataSheet = 'data_sheet_modules',
  FotoProofPhotovoltaicModules = 'foto_proof_photovoltaic_modules',
  EnergyUnitDataSheet = 'data_sheet_generating_unit',
  AuditReport = 'audit_report',
  IntegratedCertificate = 'integrated_grid_protection_certificate',
  IntegratedAudit = 'integrated_grid_protection_audit',
  CentralCertificate = 'central_grid_protection_certificate',
  CentralAudit = 'central_grid_protection_audit',
  PowerOfAttorney = 'power_of_attorney',
  Other = 'other',
  AssesmentOfGrid = 'assessment_of_grid',
  SitePlan = 'site_plan',
  FeedInControllabilityContract = 'feed_in_controllability_contract',
  ListOfDataPoints = 'list_of_data_points',
  SitePlanGenerationPlant = 'site_plan_generation_plant',
}
